<template>
  <div>
    <!-- <div  class="markerWrap" @click="handleClosePreView"></div>
    <span @click="handleClosePreView" class="closeIcon">
        <i class="el-dialog__close el-icon el-icon-close"></i></span>
     <el-carousel arrow="always"
      :height="'500px'"
      :autoplay="option.autoplay"
      :interval="option.interval"
      indicator-position="outside"
     >
      <el-carousel-item v-for="item in 4" :key="item">
        <img :src="src" alt="" class="preImg" />
      </el-carousel-item>
    </el-carousel> -->
    <span class="look_img" @click="handleViews">{{label}}</span>
    <el-dialog
      :visible.sync="preViewVisible"
      @close="handleClosePreView"
      close-on-click-modal
      width="60%"
      class="my-img-dialog"
      modal-append-to-body
      append-to-body
    >
      <el-carousel arrow="always"
        :height="option.height"
        :autoplay="option.autoplay"
        :interval="option.interval"
        indicator-position="outside"
      >
        <el-carousel-item v-for="item in option.data" :key="item">
          <!-- <img :src="item" alt="" class="preImg" /> -->
          <div class="img_avue" :style="{backgroundImage:'url('+item+')'}"></div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseImgPreView',
  data() {
    return {
      preViewVisible: false,
    }
  },
  props: {
    // 是否显示预览
    label: {
      type: String,
      default: function() {
        return ''
      },
    },
    // 显示图片的路径
    value: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  computed: {
    option() {
      let str = ''
      this.value.forEach(element => {
        if (element) str += ',' + element
      })
      const list = str.substring(1, str.length).split(',')
      return {
        autoplay: true,
        height: '500px',
        fullscreen: false,
        interval: 3000,
        data: list,
      }
    },
  },
  created() {},
  watch: {},
  methods: {
    handleClosePreView: function() {
      this.preViewVisible = false
      this.$emit('dialogChange', false)
    },
    handleViews() {
      this.preViewVisible = true
      this.$emit('dialogChange', true)
    },
  },
}
</script>
<style lang="scss">
.my-img-dialog .el-dialog{
  background-color: rgba(0,0,0,0)!important;
  box-shadow: 0 0 0 rgba(0,0,0,0);
  .el-dialog__header{
    border-bottom: none!important;
  }
  .el-dialog__close{
    color: #fff;
  }
}
.look_img{
  color: #2D7CFF;
  text-decoration:underline;
  margin-left: 10px;
}
.img_avue{
     background-repeat: no-repeat;
    background-size: contain;
    background-position: 50%;
    height: 100%;
}
</style>
